import { useNavigate } from 'react-router-dom';
import '../Catalogs/Catalogs.css';

function IconBack() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="15 18 9 12 15 6" />
    </svg>
  );
}

/* ── Picker icons (36x36, Feather-style) ──────── */
function IconStatusHistory() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  );
}

function IconTimeAudit() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
      <path d="M19.07 4.93l1.41 1.41" />
    </svg>
  );
}

function IconCommentAudit() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  );
}

function IconDevAssignment() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <polyline points="16 11 18 13 22 9" />
    </svg>
  );
}

const PICKER_CARDS = [
  { key: 'status_history', label: 'Historial de Cambios de Status', icon: <IconStatusHistory /> },
  { key: 'time_logs_audit', label: 'Auditoría de Registros de Tiempo', icon: <IconTimeAudit /> },
  { key: 'requirement_devs_audit', label: 'Historial de Asignación de Desarrolladores', icon: <IconDevAssignment /> },
  { key: 'requirement_comments_audit', label: 'Auditoría de Comentarios en Requerimientos', icon: <IconCommentAudit /> },
];

function LogsPicker({ onSelect }) {
  const navigate = useNavigate();

  return (
    <div className="log-picker">
      <div className="cat-crud-header">
        <button type="button" className="cat-back-btn" onClick={() => navigate('/admin')}>
          <IconBack />
          <span>Regresar</span>
        </button>
        <h1 className="cat-crud-title">Registros de Comportamiento</h1>
        <div style={{ width: '80px' }} />
      </div>
      <p className="log-picker-sub">Selecciona un registro para consultar su historial</p>
      <div className="log-picker-grid">
        {PICKER_CARDS.map((card, i) => (
          <button
            key={card.key}
            className="log-picker-card"
            style={{ '--delay': `${i * 70}ms` }}
            onClick={() => onSelect(card.key)}
          >
            <span className="log-picker-icon">{card.icon}</span>
            <span className="log-picker-label">{card.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default LogsPicker;
